/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Features_Tab_LayoutsInputs */

const en_cad_features_tab_layouts = /** @type {(inputs: Cad_Features_Tab_LayoutsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Layouts & plot`)
};

/**
* | output |
* | --- |
* | "Layouts & plot" |
*
* @param {Cad_Features_Tab_LayoutsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_features_tab_layouts = /** @type {((inputs?: Cad_Features_Tab_LayoutsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Features_Tab_LayoutsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_features_tab_layouts(inputs)
});
export { cad_features_tab_layouts as "cad.features.tab_layouts" }